import { styled as c, Skeleton as i, Typography as p, Box as d } from "@mui/material";
import g from "../next/Image.js";
import * as y from "ramda";
import * as k from "ramda-adjunct";
import { jsx as t } from "react/jsx-runtime";
const l = c(i)`
  transform: unset;
  & {
    // set & here (more specify), avoid background being overrided outside
    background-color: rgba(255, 255, 255, 0.1);
  }
`, S = c(p)``, f = (r) => {
  const {
    className: o,
    loading: e,
    children: s,
    ...n
  } = r;
  return e ? /* @__PURE__ */ t(l, {
    className: `${o} Custom-Skeleton`
  }) : /* @__PURE__ */ t(d, {
    className: o,
    ...n,
    children: s
  });
}, x = (r) => {
  const {
    className: o,
    children: e,
    loading: s,
    ...n
  } = r, a = s || y.isNil(e), m = a ? `${o} Custom-Typography-Skeleton` : o;
  return /* @__PURE__ */ t(S, {
    className: m,
    ...n,
    children: a ? /* @__PURE__ */ t(l, {}) : e
  });
}, b = (r) => {
  const {
    className: o,
    loading: e,
    src: s,
    ...n
  } = r;
  return e || k.isNilOrEmpty(s) ? /* @__PURE__ */ t(l, {
    className: o
  }) : /* @__PURE__ */ t(g, {
    src: s,
    className: o,
    ...n
  });
};
export {
  f as SkeletonBox,
  b as SkeletonImage,
  x as SkeletonTypography
};
//# sourceMappingURL=Skeleton.js.map
